// All mock data for SITROOM

export const incidents = [
  {
    id: "INC-2024-0891",
    title: "JIS Sequence Error — Line 7 Body Shop",
    parties: "BMW Regensburg ↔ Inteva Products",
    severity: "s1",
    status: "escalated",
    sla: 103,
    age: "4h 03m",
    partNumber: "63-12-7-345-892",
    line: "Line 7 — Body Shop",
    impact: "47 units · 2.3h",
    loss: "€84,600",
    template: "JIS Sequence Error",
    opener: "K. Horváth",
    description:
      "JIS sequence delivery deviated from call-off by 14 positions on line 7. Halt triggered at 10:28. Root cause investigation underway with Inteva Products (seat module supplier).",
    linkedParties: [
      { name: "BMW Regensburg", role: "OEM", color: "#185FA5" },
      { name: "Inteva Products", role: "TIER 1", color: "#27ae60" },
      { name: "BMW JIS Center", role: "JIS Center", color: "#E24B4A" },
      { name: "DB Schenker", role: "Road Carrier", color: "#f39c12" },
    ],
    slaTier: "S1 (Ack: 15min · Resolve: 4h)",
    ackStatus: { state: "met", text: "✓ 7 min", percent: 47 },
    resStatus: { state: "breach", text: "⚠ 4h 03m BREACH", percent: 100 },
    timeline: [
      { dot: "red", time: "10:28:59", text: "K. Horváth opened incident via JIS Sequence Error template" },
      { dot: "blue", time: "10:35:12", text: "Inteva Products acknowledged — responding party confirmed" },
      { dot: "amber", time: "11:02:44", text: "SLA 75% warning triggered — escalation pending" },
      { dot: "red", time: "12:31:00", text: "SLA breach — auto-escalated to management tier" },
    ],
    comments: [
      { initials: "KH", author: "K. Horváth", time: "10:35", text: "Line 7 halted. Inteva JIS delivery is off by 14 seats. Switching to manual sequencing. Expected 90 min delay." },
      { initials: "RS", author: "R. Szabó (Inteva)", time: "11:22", text: "Root cause: ERP sync failure. Fix deployed, correct sequence dispatch ETA 13:00." },
      { initials: "ML", author: "M. Lehr (BMW Logistics)", time: "14:05", text: "Line 7 partially restarted at 60% capacity. Full recovery expected 15:30." },
    ],
  },
  {
    id: "INC-2024-0888",
    title: "Line Stoppage — Wiring harness shortage",
    parties: "BMW Regensburg ↔ Leoni AG",
    severity: "s1",
    status: "in-progress",
    sla: 78,
    age: "3h 07m",
    partNumber: "61-13-9-241-114",
    line: "Line 4 — Assembly",
    impact: "31 units · 1.8h",
    loss: "€52,300",
    template: "Line Stoppage",
    opener: "T. Bauer",
    description:
      "Wiring harness inventory critically low. Production paused on Line 4 pending emergency replenishment from Leoni AG.",
    linkedParties: [
      { name: "BMW Regensburg", role: "OEM", color: "#185FA5" },
      { name: "Leoni AG", role: "TIER 1", color: "#27ae60" },
      { name: "Rhenus 4PL", role: "4PL", color: "#f39c12" },
    ],
    slaTier: "S1 (Ack: 15min · Resolve: 4h)",
    ackStatus: { state: "met", text: "✓ 11 min", percent: 73 },
    resStatus: { state: "warning", text: "⚠ 78% used", percent: 78 },
    timeline: [
      { dot: "red", time: "09:21:04", text: "T. Bauer opened incident — wiring harness shortage" },
      { dot: "blue", time: "09:32:18", text: "Leoni AG acknowledged" },
      { dot: "amber", time: "11:55:00", text: "SLA 75% warning triggered" },
    ],
    comments: [
      { initials: "TB", author: "T. Bauer", time: "09:25", text: "Line 4 stopped. Awaiting Leoni emergency dispatch." },
      { initials: "JF", author: "J. Falk (Leoni)", time: "09:50", text: "Emergency batch loaded. Truck departing Roth at 10:15." },
    ],
  },
  {
    id: "INC-2024-0884",
    title: "Inbound premium freight — Air charter",
    parties: "Frankfurt → Regensburg · DHL Aviation",
    severity: "s1",
    status: "acknowledged",
    sla: 35,
    age: "1h 24m",
    partNumber: "—",
    line: "Inbound",
    impact: "Charter en route",
    loss: "€28,900",
    template: "Inbound Transport Delay",
    opener: "A. Köhler",
    description:
      "Premium air charter dispatched from Frankfurt to cover sequence gap. ETA Regensburg 16:00.",
    linkedParties: [
      { name: "BMW Regensburg", role: "OEM", color: "#185FA5" },
      { name: "DHL Aviation", role: "Air Carrier", color: "#185FA5" },
      { name: "Dachser SE", role: "Freight Fwd.", color: "#27ae60" },
    ],
    slaTier: "S1 (Ack: 15min · Resolve: 4h)",
    ackStatus: { state: "met", text: "✓ 9 min", percent: 60 },
    resStatus: { state: "met", text: "35% used", percent: 35 },
    timeline: [
      { dot: "red", time: "13:18:00", text: "A. Köhler opened — premium freight authorized" },
      { dot: "blue", time: "13:27:11", text: "DHL Aviation acknowledged" },
    ],
    comments: [
      { initials: "AK", author: "A. Köhler", time: "13:30", text: "Charter MD-11F dispatched. ETA 16:00 Regensburg." },
    ],
  },
  {
    id: "INC-2024-0879",
    title: "Quality Lock — Seat trim defect (PPM)",
    parties: "BMW Regensburg ↔ Inteva Products",
    severity: "s2",
    status: "in-progress",
    sla: 65,
    age: "6h 14m",
    partNumber: "52-10-7-411-228",
    line: "Quality Hold Bay 3",
    impact: "112 units quarantined",
    loss: "€19,400",
    template: "Quality Lock",
    opener: "N. Richter",
    description:
      "PPM spike detected on seat trim. 112 units quarantined pending containment action by Inteva quality team.",
    linkedParties: [
      { name: "BMW Quality", role: "OEM Quality", color: "#185FA5" },
      { name: "Inteva Products", role: "TIER 1 Quality", color: "#f39c12" },
      { name: "Visintro Kft.", role: "Sorting SP", color: "#27ae60" },
    ],
    slaTier: "S2 (Ack: 30min · Resolve: 8h)",
    ackStatus: { state: "met", text: "✓ 14 min", percent: 47 },
    resStatus: { state: "warning", text: "65% used", percent: 65 },
    timeline: [
      { dot: "red", time: "08:00:00", text: "N. Richter opened quality lock" },
      { dot: "blue", time: "08:14:00", text: "Inteva acknowledged" },
      { dot: "amber", time: "12:30:00", text: "Containment plan submitted" },
    ],
    comments: [],
  },
  {
    id: "INC-2024-0875",
    title: "Inbound transport delay — DB Schenker FTL",
    parties: "Budapest → Regensburg",
    severity: "s2",
    status: "in-progress",
    sla: 55,
    age: "4h 50m",
    partNumber: "—",
    line: "Inbound",
    impact: "Truck delayed 3h",
    loss: "€7,200",
    template: "Inbound Transport Delay",
    opener: "P. Walter",
    description: "DB Schenker FTL from Budapest delayed by border congestion. Revised ETA 17:45.",
    linkedParties: [
      { name: "BMW Logistics", role: "OEM Logistics", color: "#185FA5" },
      { name: "DB Schenker", role: "Road Carrier", color: "#f39c12" },
    ],
    slaTier: "S2 (Ack: 30min · Resolve: 8h)",
    ackStatus: { state: "met", text: "✓ 22 min", percent: 73 },
    resStatus: { state: "met", text: "55% used", percent: 55 },
    timeline: [
      { dot: "red", time: "09:35:00", text: "P. Walter opened transport delay" },
      { dot: "blue", time: "09:57:00", text: "DB Schenker acknowledged" },
    ],
    comments: [],
  },
  {
    id: "INC-2024-0871",
    title: "Packaging shortage — KLT pool imbalance",
    parties: "BMW Regensburg ↔ LPR Pooling",
    severity: "s3",
    status: "open",
    sla: 20,
    age: "1h 05m",
    partNumber: "KLT-6410",
    line: "Packaging Yard",
    impact: "Pool deficit 1,200 units",
    loss: "€2,100",
    template: "Packaging Shortage",
    opener: "C. Vogel",
    description: "KLT pool imbalance detected. Empty container deficit forecast for evening shift.",
    linkedParties: [
      { name: "BMW Regensburg", role: "OEM", color: "#185FA5" },
      { name: "LPR Pooling", role: "Pkg. Operator", color: "#185FA5" },
    ],
    slaTier: "S3 (Ack: 1h · Resolve: 24h)",
    ackStatus: { state: "met", text: "20% used", percent: 20 },
    resStatus: { state: "met", text: "20% used", percent: 20 },
    timeline: [{ dot: "red", time: "13:25:00", text: "C. Vogel opened packaging incident" }],
    comments: [],
  },
];

export const tenants = [
  { initials: "BM", name: "BMW Regensburg", id: "tenant-OEM-001", type: "OEM · Layer 1", sla: "61%", slaTone: "amber", integrations: "SSO + Webhook" },
  { initials: "LE", name: "Leoni AG", id: "tenant-T1-007", type: "TIER1 · Layer 1", sla: "72%", slaTone: "blue", integrations: "API Key" },
  { initials: "IN", name: "Inteva Products", id: "tenant-T1-009", type: "TIER1 · Layer 1", sla: "BREACH", slaTone: "red", integrations: "API Key" },
  { initials: "DA", name: "Dachser SE", id: "tenant-FF-014", type: "Forwarder · Layer 3", sla: "100%", slaTone: "green", integrations: "⟳ Webhook pending" },
  { initials: "JC", name: "BMW JIS Center", id: "tenant-JIS-003", type: "JIS · Layer 4", sla: "BREACH", slaTone: "red", integrations: "SSO" },
  { initials: "DH", name: "DHL Aviation", id: "tenant-AC-022", type: "Air · Layer 3", sla: "88%", slaTone: "blue", integrations: "API Key + Webhook" },
];

export const chainLayers = [
  {
    label: "PRODUCTION",
    nodes: [
      { name: "BMW Regensburg", type: "OEM · Tier 0", sev: "s1", incidentId: "INC-2024-0891" },
      { name: "Leoni AG", type: "TIER 1", sev: "s1", incidentId: "INC-2024-0888" },
      { name: "Inteva Products", type: "TIER 1", sev: "s1", incidentId: "INC-2024-0891" },
      { name: "Rehau AG", type: "TIER 2", sev: "s2" },
      { name: "Schnellecke", type: "TIER 3+", sev: null },
    ],
  },
  {
    label: "ENGINEERING",
    nodes: [
      { name: "Visintro Kft.", type: "Sorting SP", sev: null },
      { name: "ZF Test Center", type: "Measurement Lab", sev: null },
      { name: "Bertrandt AG", type: "Engineering SP", sev: null },
      { name: "TÜV Süd", type: "Certification", sev: null },
    ],
  },
  {
    label: "LOGISTICS",
    nodes: [
      { name: "DHL Aviation", type: "Air Carrier", sev: "s1", incidentId: "INC-2024-0884" },
      { name: "DB Schenker", type: "Road Carrier", sev: "s2" },
      { name: "Dachser SE", type: "Freight Fwd.", sev: null },
      { name: "Hellmann", type: "Road Carrier", sev: null },
      { name: "Rhenus 4PL", type: "4PL", sev: null },
    ],
  },
  {
    label: "WAREHOUSE",
    nodes: [
      { name: "Hörmann", type: "3PL", sev: null },
      { name: "BMW JIS Center", type: "JIS Center", sev: "s1", incidentId: "INC-2024-0891" },
      { name: "LPR Pooling", type: "Pkg. Operator", sev: null },
    ],
  },
  {
    label: "INDIRECT",
    nodes: [
      { name: "Allianz Trade", type: "Insurance", sev: null },
      { name: "Bundesamt", type: "Regulatory", sev: null },
    ],
  },
];

export const categoryBars = [
  { name: "Quality", value: 12, color: "#E24B4A" },
  { name: "Transport", value: 9, color: "#f39c12" },
  { name: "Stoppage", value: 8, color: "#E24B4A" },
  { name: "JIS", value: 7, color: "#f39c12" },
  { name: "Pkg.", value: 6, color: "#185FA5" },
  { name: "Other", value: 5, color: "#9198b0" },
];

export const slaBars = [
  { name: "S1", value: 61, color: "#E24B4A" },
  { name: "S2", value: 78, color: "#f39c12" },
  { name: "S3", value: 91, color: "#185FA5" },
  { name: "S4", value: 97, color: "#27ae60" },
];

export const mttrBars = [
  { name: "Leoni AG", hours: 8.5, percent: 100, color: "#E24B4A" },
  { name: "Inteva", hours: 7.2, percent: 85, color: "#E24B4A" },
  { name: "DB Schenker", hours: 6.0, percent: 71, color: "#f39c12" },
  { name: "Rehau", hours: 4.5, percent: 53, color: "#f39c12" },
  { name: "BMW JIS", hours: 2.8, percent: 33, color: "#185FA5" },
  { name: "Hörmann", hours: 2.0, percent: 24, color: "#185FA5" },
];

export const rootCauses = [
  { name: "Supplier forecast inaccuracy", count: 9, percent: 100, color: "#E24B4A" },
  { name: "JIS window mismatch", count: 7, percent: 78, color: "#f39c12" },
  { name: "Carrier capacity shortage", count: 6, percent: 67, color: "#f39c12" },
  { name: "Packaging return loop delay", count: 5, percent: 56, color: "#185FA5" },
];

export const templates = [
  { value: "", label: "— Select template —" },
  { value: "jis", label: "JIS Sequence Error (S1)", sev: "s1" },
  { value: "stoppage", label: "Line Stoppage — Active (S1)", sev: "s1" },
  { value: "quality", label: "Quality Lock (S2)", sev: "s2" },
  { value: "transport", label: "Inbound Transport Delay (S2–S3)", sev: "s2" },
  { value: "packaging", label: "Packaging Shortage (S3)", sev: "s3" },
  { value: "customs", label: "Customs / Border Hold (S2)", sev: "s2" },
  { value: "damage", label: "Warehouse Damage / Loss (S3)", sev: "s3" },
  { value: "material", label: "Raw Material Shortage (S2)", sev: "s2" },
];

export const templatePartiesMap = {
  jis: ["OEM Production", "JIS Center", "TIER 1", "Road Carrier"],
  stoppage: ["OEM Production", "TIER 1", "4PL", "Air Carrier"],
  quality: ["OEM Quality", "TIER 1 Quality", "Sorting SP", "Measurement Lab"],
  transport: ["OEM Logistics", "TIER 1", "Road Carrier", "Freight Forwarder"],
  packaging: ["OEM", "TIER 1", "Pkg. Operator", "Milk Run Carrier"],
  customs: ["OEM", "TIER 1", "Customs Broker", "Freight Forwarder"],
  damage: ["OEM / TIER 1", "3PL Warehouse", "Insurance (Observer)"],
  material: ["TIER 1", "TIER 2", "Raw Material Supplier", "4PL"],
};

export const severityColor = (sev) => {
  switch (sev) {
    case "s1": return "#E24B4A";
    case "s2": return "#f39c12";
    case "s3": return "#185FA5";
    case "s4": return "#9198b0";
    default: return "#9198b0";
  }
};

export const statusStyle = (status) => {
  const map = {
    open: { bg: "rgba(122,128,153,0.12)", border: "rgba(122,128,153,0.4)", color: "#9aa1b3", label: "OPEN" },
    acknowledged: { bg: "rgba(24,95,165,0.15)", border: "rgba(24,95,165,0.5)", color: "#5fa3e3", label: "ACKNOWLEDGED" },
    "in-progress": { bg: "rgba(243,156,18,0.13)", border: "rgba(243,156,18,0.5)", color: "#f3b14a", label: "IN PROGRESS" },
    escalated: { bg: "rgba(226,75,74,0.14)", border: "rgba(226,75,74,0.55)", color: "#ff7e7c", label: "ESCALATED" },
    resolved: { bg: "rgba(39,174,96,0.13)", border: "rgba(39,174,96,0.5)", color: "#4ed084", label: "RESOLVED" },
    closed: { bg: "rgba(60,65,80,0.3)", border: "rgba(120,125,140,0.3)", color: "#9198b0", label: "CLOSED" },
  };
  return map[status] || map.open;
};


export const fmeaSuggestions = [
  {
    id: "FMEA-0891",
    sourceIncident: "INC-2024-0891",
    source8D: "8D-2024-0041",
    sourceClosed: true,
    failureMode: "JIS sequence deviation — seat module delivery offset",
    effect: "Line stoppage 2.3h, 47 units lost, €84,600",
    cause: "ERP sync failure between Inteva Products and BMW JIS scheduling system",
    currentControls: "Manual sequence check at dock — daily",
    severity: 9,
    occurrence: 6,
    detection: 7,
    aiScored: true,
    recommendedAction:
      "Implement automated ERP sync validation with pre-shift sequence confirmation alert. Add redundant manual check at T-2h before JIS window.",
    status: "pending",
    generatedBy: "auto",
    generatedAt: "2026-02-12 13:42",
    reviewedBy: null,
    // Extended FMEA columns
    businessFunction: "JIS Logistics",
    processStep: "Sequenced seat module dispatch",
    responsibility: "R. Szabó (Inteva) — 2024-03-22",
    actionsTaken: "ERP watchdog + auto-rollback deployed 2024-03-22; T-2h validation alarm 2024-03-25.",
    newSeverity: 9,
    newOccurrence: 2,
    newDetection: 3,
  },
  {
    id: "FMEA-0855",
    sourceIncident: "INC-2024-0855",
    source8D: "8D-2024-0038",
    sourceClosed: true,
    failureMode: "Wiring harness buffer stock depletion",
    effect: "Line stoppage 1.8h, 31 units, €55,800",
    cause: "Supplier forecast inaccuracy — Leoni AG safety stock below 4h threshold",
    currentControls: "Weekly stock review",
    severity: 9,
    occurrence: 7,
    detection: 6,
    recommendedAction:
      "Set minimum buffer stock to 8h production equivalent. Implement daily automated stock level alert from Leoni AG WMS.",
    status: "approved",
    generatedBy: "auto",
    generatedAt: "2026-01-28 09:14",
    reviewedBy: "M. Lehr",
    businessFunction: "Inbound Supply Planning",
    processStep: "Tier 1 stock replenishment",
    responsibility: "Leoni Planning — 2024-02-20",
    actionsTaken: "Buffer raised to 8h; daily WMS auto-alert active since 2024-02-20.",
    newSeverity: 9,
    newOccurrence: 3,
    newDetection: 3,
  },
  {
    id: "FMEA-0831",
    sourceIncident: "INC-2024-0831",
    source8D: "8D-2024-0035",
    sourceClosed: true,
    failureMode: "KLT packaging pool imbalance",
    effect: "Degraded delivery risk, 12h buffer, €3,200 exposure",
    cause: "Return loop delay — empty KLT not collected on schedule",
    currentControls: "Monthly pool audit",
    severity: 5,
    occurrence: 8,
    detection: 5,
    recommendedAction:
      "Automate KLT pool balance monitoring with threshold alert at <200 units. Add return pickup to standard milk-run schedule.",
    status: "pending",
    generatedBy: "auto",
    generatedAt: "2026-01-15 16:02",
    reviewedBy: null,
    businessFunction: "Packaging Operations",
    processStep: "KLT return-loop pickup",
    responsibility: "LPR Ops — 2024-03-01",
    actionsTaken: "Pending approval — milk-run reroute proposed.",
    newSeverity: 5,
    newOccurrence: 4,
    newDetection: 3,
  },
];

export const fmeaStatusStyle = (status) => {
  const map = {
    pending: { bg: "rgba(243,156,18,0.13)", border: "rgba(243,156,18,0.5)", color: "#f3b14a", label: "PENDING REVIEW" },
    approved: { bg: "rgba(39,174,96,0.13)", border: "rgba(39,174,96,0.5)", color: "#4ed084", label: "APPROVED" },
    rejected: { bg: "rgba(226,75,74,0.14)", border: "rgba(226,75,74,0.55)", color: "#ff7e7c", label: "REJECTED" },
  };
  return map[status] || map.pending;
};

export const rpnColor = (rpn) => {
  if (rpn >= 200) return "#E24B4A";
  if (rpn >= 100) return "#f39c12";
  return "#27ae60";
};

export const FMEA_PURPLE = "#8e44ad";
